module.exports = __webpack_public_path__ + "img/gril.878a9ee4.png";